import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { jsPDF } from 'jspdf';
import categoryService from '../../services/CategoryService';
import Nav from '../../components/material/NavMaterial';
import Slide from '../../components/material/SlideActionCategory';
import "../../static/css/datatable.css";

export default function Category({ itemsPerPage = 25 }) {
    const { register, watch, handleSubmit, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(true);
    const [results, setResults] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPageLocal, setItemsPerPageLocal] = useState(itemsPerPage);
    const [isSlideOpen, setIsSlideOpen] = useState(false);
    const [openAction, setOpenAction] = useState(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [loadSlide, setLoadSlide] = useState(false);
    const [category, setCategory] = useState({});

    const search = watch("search", "");

    const totalPages = Math.ceil(results.length / itemsPerPageLocal);
    const startIndex = (currentPage - 1) * itemsPerPageLocal;
    const endIndex = startIndex + itemsPerPageLocal;
    const currentItems = results.slice(startIndex, endIndex);

    const fetchCategories= async (search) => {
        try {
            const res = await categoryService.getFilter(search);
            // Estrarre i dati specifici dalla struttura complessa di response.data
            const resultsData = res.data || [];
            const total = res.data.length || 0;

            setResults(resultsData); // Salva i risultati
            setTotalResults(total); // Salva il totale dei risultati
            setCurrentPage(1);
            setLoading(false);
            // Calcoliamo dinamicamente itemsPerPageLocal dopo aver ricevuto i dati
            const defaultItemsPerPage = Math.min(itemsPerPage, total);
            setItemsPerPageLocal(defaultItemsPerPage);

        } catch (error) {
            console.error('Error fetching clients', error);
        }
    };

    useEffect(() => {
        fetchCategories(search);
    }, [search]);

    const goToPage = (page) => {
        setCurrentPage(page);
    };
    const handleItemsPerPageChange = (event) => {
        setItemsPerPageLocal(parseInt(event.target.value, 10));
        setCurrentPage(1);
    };
    const generateItemsPerPageOptions = () => {
        const options = [];
        const maxItems = totalResults;

        if (maxItems <= 2) {
            options.push(2);
        } else if (20 <= maxItems && maxItems <= 50){
            options.push(10, 25, maxItems);
        } else if (maxItems > 50) {
            options.push(10, 25, 50);
        } else {
            for (let i = 2; i <= maxItems; i *= 2) {
             if (i < maxItems) options.push(i);
            }
            if (maxItems > 2) options.push(maxItems);
        }
        return options;
    };

    const toggleSlide = (itemCategory) => {
        setLoadSlide(true);
        setCategory(itemCategory);
        setIsSlideOpen(!isSlideOpen);
    };

    const handleActionClick = (index,e) => {
        const rect = e.target.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const offsetY = e.clientY - rect.top;
        const adjustedX = offsetX - 80;
        const adjustedY = offsetY - 10;

        setPosition((prevPositions) => ({
              ...prevPositions,
              [index]: { x: adjustedX, y: adjustedY }, // Imposta la posizione dell'elemento
            }));
        setOpenAction(openAction === index ? null : index);
    };

    const getFormattedDate = () => {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${day}-${month}-${year}`;
    };
    const handleExportPDF = () => {
        const doc = new jsPDF('l', 'mm', 'a4');//configuro con l(stampa orizzontale)
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(12);
        doc.text("Lista Eventi", 14, 10); //Titolo
        doc.autoTable({
            head: [['NR','Evento','Contatti','Montaggio','Smontaggio','Vettore','Note']], // Intestazioni della tabella
            body: results.map((event, index) => [index + 1,`${event.name}\n${event.year}\n${event.address}\n${event.city}\n${event.startDate} ${event.endDate}`,
                `Telefono: ${event.phone}\nEmail: ${event.email}`,
                `Inizio: ${event.startAssembly}\nFine ${event.endAssembly}`,
                `Inizio: ${event.startDisassembly}\nFine: ${event.endDisassembly}`,
                `Nome: ${event.vector ? event.vector.name : 'Non selezionato'}\nIndirizzo: ${event.vector ? event.vector.address : 'Non selezionato'}`,
                event.note]), // Corpo della tabella
            startY: 20, // Imposta la posizione di inizio della tabella
            theme: 'grid', // Aggiungi griglia alla tabella
        });
        doc.save(`event_${getFormattedDate()}.pdf`);
    };

  	return (
  	<>
        <div className="row">
            <div className="col-md-12">
                {/* Nav Category */}
                <Nav />
            </div>
        </div>
  	    <div className="card">
            {/* List Category */}
            <div className="card-datatable table-responsive">
                <div className="dataTables_wrapper dt-bootstrap5 no-footer">
                    <div className="row">
                        <div className="col-md-2">
                            <div className="dataTables_length">
                                <label>
                                    <select name="DataTables_Table_0_length" className="form-select" id="itemsPerPage"
                                        value={itemsPerPageLocal} onChange={handleItemsPerPageChange}>
                                        {generateItemsPerPageOptions().map((value) => (
                                            <option key={value} value={value}>{value}</option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                        </div>
                        <div className="col-md-10">
                            <div className="dt-action-buttons text-xl-end text-lg-start text-md-end text-start d-flex align-items-center justify-content-end flex-md-row flex-column mb-6 mb-md-0 mt-n6 mt-md-0">
                                <div className="dataTables_filter">
                                    <label>
                                        <input className="form-control" type="text"
                                            placeholder="Cerca per ..."
                                            {...register('search')}
                                        />
                                    </label>
                                </div>
                                <div className="dt-buttons btn-group flex-wrap">
                                    <div className="btn-group">
                                    {/* onClick={handleExportPDF} */}
                                        <button  className="btn buttons-collection dropdown-toggle btn-label-secondary mx-4" type="button" >
                                            <span><i className="bx bx-export me-2 bx-sm"></i>Export</span>
                                        </button>
                                    </div>
                                    {/* Pulsante per aprire il modulo di aggiunta evento */}
                                    <button className="btn add-new btn-primary" onClick={() => toggleSlide(null)}>
                                         <span>
                                            <i className="bx bx-plus bx-sm me-0 me-sm-2"></i>
                                            <span className="d-none d-sm-inline-block">Aggiungi</span>
                                         </span>
                                   </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table className="datatables-users table border-top dataTable no-footer dtr-column">
                        <thead>
                            <tr>
                                <th>NOME</th>
                                <th>CATEGORIA PADRE</th>
                                <th>VIEW</th>
                                <th>AZIONI</th>
                            </tr>
                        </thead>
                        {loading && (
                        <tbody>
                            <tr className="odd">
                                <td className="dataTables_empty">Loading...</td>
                            </tr>
                        </tbody>
                        )}
                        <tbody>
                         {currentItems.map((result,index) => (
                            <tr key={result.id_category}>
                                <td>{result.name}</td>
                                <td>{result.parent}</td>
                                <td>{result.view}</td>
                                <td>
                                    <div className="dropdown">
                                        <button type="button" className="btn p-0" onClick={(e) => handleActionClick(index,e)}>
                                            <i className="bx bx-dots-vertical-rounded"></i>
                                        </button>
                                        <div className={`dropdown-menu ${openAction === index ? "show-action" : ""}`}
                                            style={{
                                                position: 'absolute',
                                                transform: position[index]
                                                    ? `translate3d(${position[index].x}px, ${position[index].y}px, 0px)`
                                                    : 'translate3d(0px, 0px, 0px)',
                                                transition: 'transform 0.3s ease',
                                            }}
                                        >
                                        <a className="dropdown-item" onClick={() => toggleSlide(result)}>
                                            <i className="bx bx-edit-alt me-1"></i>Modifica
                                        </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                          ))}
                        </tbody>
                    </table>
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <div className="dataTables_info" role="status" aria-live="polite">
                                Risultati ottenuti : {totalResults}
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6">
                            <div className="dataTables_paginate paging_simple_numbers custom-ryo">
                                {!loading && (
                                    <div className="pagination">
                                        <button className="page-link" onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                                            <i className="bx bx-chevron-left bx-18px"></i>
                                        </button>
                                        {Array.from({ length: totalPages }, (_, index) => (
                                            <button
                                              key={index + 1}
                                              onClick={() => goToPage(index + 1)}
                                              disabled={currentPage === index + 1}
                                              className={`page-link ${currentPage === index + 1  ? "current-page" : ""}`}
                                            >
                                              {index + 1}
                                            </button>
                                        ))}
                                        <button className="page-link" onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>
                                            <i className="bx bx-chevron-right bx-18px"></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Slide */}
            { loadSlide && (
                <Slide show={isSlideOpen} onClose={toggleSlide} onFetchCategories={fetchCategories} search={search} category={category}/>
                )
            }
            {/* Slide */}
            {/* /List Category*/}
  	    </div>
    </>
	);

}
